module.exports = __webpack_public_path__ + "img/沉香.6e498289.jpg";